
define(['jquery', 'underscore'], function($, _) {
  var Combobox;
  return Combobox = (function() {

    Combobox.prototype.controlHtml = '';

    function Combobox(name, id, clazz, list, selectedValue, fields, defaultOption) {
      var item, selected, _i, _len, _ref;
      this.name = name != null ? name : null;
      this.id = id != null ? id : null;
      this.clazz = clazz != null ? clazz : null;
      this.list = list;
      this.selectedValue = selectedValue != null ? selectedValue : null;
      this.fields = fields != null ? fields : {
        name: 'name',
        value: 'value'
      };
      this.defaultOption = defaultOption != null ? defaultOption : null;
      this.controlHtml = "<select name='" + name + "' id='" + id + "' class='" + clazz + "'>";
      if (this.defaultOption) {
        this.controlHtml += "<option value='" + this.defaultOption.value + "'>" + this.defaultOption.name + "</option>";
      }
      _ref = this.list;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        item = _ref[_i];
        selected = item[this.fields.value] === this.selectedValue ? 'selected="selected"' : '';
        name = _.isString(this.fields.name) ? item[this.fields.name] : _.isFunction(this.fields.name) ? this.fields.name.call(null, item) : void 0;
        this.controlHtml += "<option value='" + item[this.fields.value] + "' " + selected + ">" + name + "</option>";
      }
      this.controlHtml += '</select>';
    }

    Combobox.prototype.show = function() {
      return this.controlHtml;
    };

    return Combobox;

  })();
});
